import { ReactNode } from 'react';
import Navigation from './Navigation';

interface DashboardLayoutProps {
  children: ReactNode;
}

export default function DashboardLayout({ children }: DashboardLayoutProps) {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
      <Navigation />
      <main className="max-w-7xl mx-auto">
        {children}
      </main>
    </div>
  );
}
